import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {
        // Auto-play failed
      });
    }

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Calculate animation values based on scroll
  const opacity = Math.max(0, 1 - scrollY / 300);
  const scale = Math.max(0.3, 1 - scrollY / 800);
  const translateY = scrollY * 0.5;

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* Full Screen Video */}
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          className="w-full h-full object-cover"
          loop
          muted
          playsInline
          autoPlay
        >
          <source src="/spotlight.webm" type="video/webm" />
          <source src="/spotlight.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        {/* Video Overlay */}
        <div className="absolute inset-0 bg-black/10"></div>
      </div>

      {/* ELARA Logo in Hero - Animates on scroll */}
      <div className="relative z-10 h-full flex items-center justify-center pt-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          style={{
            opacity: opacity,
            scale: scale,
            transform: `translateY(-${translateY}px)`,
          }}
          className="transition-all duration-300 ease-out"
        >
          <h1 className="text-6xl font-serif font-bold tracking-[0.3em] text-white text-center">
            ELARA
          </h1>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;